import React from 'react';
import { Twitter, Send, MessageCircle, Instagram } from 'lucide-react';
import { mockData } from '../mock/mockData';

const Community = () => {
  const { social } = mockData;

  const iconMap = {
    twitter: <Twitter size={32} />,
    send: <Send size={32} />,
    messageCircle: <MessageCircle size={32} />,
    instagram: <Instagram size={32} />
  };

  return (
    <section id="community" className="community-section">
      <div className="section-container">
        <h2 className="section-title">{social.title}</h2>
        
        <div className="social-grid">
          {social.links.map((link, index) => (
            <a 
              key={index}
              href={link.url}
              className="social-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="social-icon">
                {iconMap[link.icon]}
              </div>
              <span className="social-name">{link.name}</span>
            </a>
          ))}
        </div>

        <div className="community-cta">
          <img 
            src="https://images.unsplash.com/photo-1592530392525-9d8469678dac"
            alt="Join the Revolution"
            className="community-bg-image"
          />
          <div className="community-overlay">
            <h3 className="community-overlay-title">JOIN THE REVOLUTION</h3>
            <p className="community-overlay-text">Be part of the supreme crypto movement</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Community;
